<template>
  <div>
    <b-container fluid class="tw-mb-5">
      <b-row class="tw-bg-gray-100 tw-border tw-border-blue-200">
        <b-col cols="9" class="tw-overflow-x-scroll">
          <bar-chart
            v-if="loaded"
            :chartData="clusterEnrollment.chartdata"
            :options="clusterEnrollment.options"
            :styles="clusterEnrollment.myStyles"
          >
          </bar-chart>
        </b-col>
        <b-col cols="3">
          <b-container>
            <b-row>
              <b-col>
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Core
                    </h6>
                    <p class="text-secondary tw-text-xs text-center">
                      Total Completed
                    </p>
                    <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">
                      {{ totalCore }}
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col>
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Buffer
                    </h6>
                    <p class="text-secondary tw-text-xs text-center">
                      Total Completed
                    </p>
                    <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">
                      {{ totalBuffer }}
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
            <!-- <b-row>
              <b-col>
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Core
                    </h6>
                    <p class="text-secondary tw-text-xs text-center">
                      Percentage Complete
                    </p>
                    <h1 class="tw-text-3xl tw-font-bolder text-center tw-mb-0">
                      {{ totalCore / coreTarget }} %
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col>
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Buffer
                    </h6>
                    <p class="text-secondary tw-text-xs text-center">
                      Percentage Complete
                    </p>
                    <h1 class="tw-text-3xl tw-font-bolder text-center tw-mb-0">
                      {{ totalBuffer / bufferTarget }} %
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row> -->
          </b-container>
          <info-popover>About this widget!</info-popover>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

// import {
//     mapState, mapGetters, mapActions
// } from 'vuex';

import * as _ from "lodash";

import BarChart from "@/components/charts/BarChart.vue";

export default {
  mixins: [],
  components: {
    BarChart
  },
  props: {},
  data() {
    return {
      loaded: false,
      coreTarget: 10,
      bufferTarget: 15,
      totalCore: 0,
      totalBuffer: 0,
      clustersReachedCoreTarget: 0,
      clustersReachedBufferTarget: 0,
      light_trap_clusters: [
          '03',
          '10',
          '12',
          '13',
          '15',
          '18',
          '19',
          '20',
          '25',
          '28',
          '30',
          '31',
          '37',
          '39',
          '42',
          '43',
          '48',
          '55',
          '57',
          '59'
      ],
      clusterEnrollment: {
        chartdata: {
          datasets: [
            {
              label: "Core",
              backgroundColor: "red",
              data: [45, 23]
            },
            {
              label: "Buffer",
              backgroundColor: "green",
              data: [42, 20]
            }
          ],
          labels: [1, 2]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top",
            labels: {
              boxWidth: 18
            }
          },
          title: {
            display: true,
            text: "Compound Enrollment Progress"
          },
          animation: {
            animateScale: true,
            animateRotate: true
          },
          scales: {
            xAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true
                },
                scaleLabel: {
                  display: true,
                  labelString: "Cluster"
                }
              }
            ],
            yAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true
                },
                scaleLabel: {
                  display: true,
                  labelString: "Enrollment Count"
                },
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        },
        myStyles: {
          height: "25vh",
          width: "100vh",
          position: "relative"
        }
      }
    };
  },
  computed: {
    // ...mapState('sample', ['sample'])
  },
  created: function() {},
  mounted: function() {
    this.get();
  },
  methods: {
    get: function() {
      let datasets = [
        {
          label: "Core",
          backgroundColor: "#37B1CA",
          data: []
        },
        {
          label: "Buffer",
          backgroundColor: "#a3d2e0",
          data: []
        },
        {
          type: "line",
          backgroundColor: "red",
          borderColor: "red",
          fill: false,
          pointRadius: 0,
          borderWidth: 1,
          label: "Core Target",
          data: []
        },
        {
          type: "line",
          backgroundColor: "orange",
          borderColor: "orange",
          fill: false,
          pointRadius: 0,
          borderWidth: 1,
          label: "Buffer Target",
          data: []
        }
      ];

      let labels = [];
      let core = {};
      let buffer = {};

      const that = this;
      HTTP.get("/kenya/lighttraps/get_this_month")
        .then(response => {
          _.each(response.data, function(item) {
            if(item.enrollment_status == 'collected'){
              if (item.core_or_buffer === "core") {
                if(item.cluster in core){
                  core[item.cluster].push(item);
                }
                else{
                  core[item.cluster] = [
                    item
                  ];
                }
              } else {
                if(item.cluster in buffer){
                  buffer[item.cluster].push(item);
                }
                else{
                  buffer[item.cluster] = [
                    item
                  ];
                }
              }
            }
          });

          for (let x_i = 0; x_i < that.light_trap_clusters.length; x_i++) {
            let x = parseInt(that.light_trap_clusters[x_i]);
            let idx_str = String(x);

            // populate the core series
            if (idx_str in core) {
              datasets[0].data.push(core[idx_str].length);
              that.totalCore += core[idx_str].length;

              if(core[idx_str].current_enrollment_count >= that.coreTarget) {
                that.clustersReachedCoreTarget += 1;
              }
            } else {
              datasets[0].data.push(0);
            }

            // populate the buffer series
            if (idx_str in buffer) {
              datasets[1].data.push(buffer[idx_str].current_enrollment_count);
              that.totalBuffer += buffer[idx_str].current_enrollment_count;

              if(buffer[idx_str].current_enrollment_count >= that.bufferTarget) {
                that.clustersReachedBufferTarget += 1;
              }
            } else {
              datasets[1].data.push(0);
            }

            labels.push(x);
            datasets[2].data.push(that.coreTarget);
            datasets[3].data.push(that.bufferTarget);
          }

          that.clusterEnrollment.chartdata.datasets = datasets;
          that.clusterEnrollment.chartdata.labels = labels;
          that.loaded = true;
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
        });
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {}
  }
};
</script>

<style>
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 0.5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: 0.35rem 0.5rem;
}

/* #bar-chart {
  height: 240px !important;
} */
</style>
